import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetAppointmentChannelDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { Selector, Option } from './Selector';

export interface AppointmentChannelSelectorProps {
  readOnly?: boolean;
  value?: string;
  placeholder?: string;
  className?: string;
  channels?: GetAppointmentChannelDto[];
  onChange?: (option: Option) => void;
}

export default (props: AppointmentChannelSelectorProps) => {
  const spd = useSpdCore();
  const [channels, setChannels] = useState<GetAppointmentChannelDto[]>([]);
  const [displayName, setDisplayName] = useState<string>();
  const [ready, setReady] = useState(false);

  const generateName = (channel: GetAppointmentChannelDto) =>
    `${channel.name || ''} (${channel.healthcareFacility?.displayName || ''})`;

  useEffect(() => {
    if (!props.value) {
      setDisplayName(undefined);
      return;
    }

    if (props.channels) {
      const selected = props.channels.find(
        channel => channel.id === props.value,
      );
      setDisplayName(selected ? generateName(selected) : undefined);
      return;
    }

    if (props.value) {
      spd.appointmentChannels
        .get(props.value || '')
        .then(et => {
          setDisplayName(generateName(et));
        })
        .catch(error =>
          console.log(
            `Wystąpił problem z pobraniem kanałów komunikacji. ${error}`,
          ),
        );
    }
  }, [props.value, props.channels, spd.appointmentChannels]);

  useEffect(() => {
    if (props.channels) {
      setChannels(props.channels);
      setReady(true);
      return;
    }

    let mounted = true;
    setReady(false);
    spd.appointmentChannels
      .getAll()
      .then(et => {
        if (mounted) {
          setChannels(et);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(
          `Wystąpił problem z pobraniem kanałów komunikacji. ${error}`,
        ),
      );

    return () => {
      mounted = false;
    };
  }, [props.channels, spd.appointmentChannels]);

  const provider = async (text: string) => {
    const values = channels.filter(v => {
      const name = v.name || '';
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });

    return values.map(v => {
      return {
        label: generateName(v),
        value: v.id,
      };
    });
  };

  return ready ? (
    <Selector
      uniqueKey={'channel-' + JSON.stringify(channels)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={props.placeholder || 'Wskaż...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
    />
  ) : (
    <Skeleton />
  );
};
